/**
 * URL-hash keys for the devices feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const DEVICES_HASH = {
  /** `#create` — DeviceFormDialog in create mode (also used for a discovered prefill). */
  create: 'create',
  /** `#edit/<id>` — DeviceFormDialog editing a specific device. */
  edit: 'edit',
  /** `#discover` — DeviceDiscoveryDialog (scanner/printer/barcode tabs). */
  discover: 'discover',
  /** `#delete/<id>` — single-device delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type DevicesHashKey = (typeof DEVICES_HASH)[keyof typeof DEVICES_HASH];
